import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

@Component({
  selector: 'rms-checklist-signature',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './rms-checklist-signature.component.html',
  styleUrl: './rms-checklist-signature.component.css'
})
export class RmsChecklistSignatureComponent implements OnInit, OnChanges {

  @Input() rmsPlanChecklistData: any;
  @Output() onSaveSection6 = new EventEmitter<any>();

  currentDate = new Date();
  rmsChecklistSignatureForm: FormGroup = new FormGroup([]);

  constructor(
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.initializeForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rmsPlanChecklistData'] && this.rmsPlanChecklistData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    this.rmsChecklistSignatureForm = new FormGroup({
      user_signature_name: new FormControl('', Validators.required),
    });
  }

  saveRmsChecklistSignature(): void {
    if (this.rmsChecklistSignatureForm.valid) {
        this.onSaveSection6.emit(this.rmsChecklistSignatureForm.value);
    }
  }

}
